import axios from "axios";
import myCfg from "./config.json";

class ServiceBackend {

    doThePost(datos, fileRecSueldo, fileAlta, fileDNI, fileDNI2, firmaOSStr, firmaSINStr, tipoForm, firmaBase64OS, firmaBase64SIN) {
        var myData = new FormData();
        datos.tipo = tipoForm;
        if (datos.paginaweblaboral=="" || datos.paginaweblaboral==undefined)
            datos.paginaweblaboral=" - ";
        myData.append('mis_datos', JSON.stringify(datos));
        myData.append('recibo_sueldo',fileRecSueldo )
        myData.append('alta_temprana', fileAlta)
        myData.append('dni', fileDNI)
        myData.append('dni-dorso', fileDNI2)
        myData.append("firma-os", firmaOSStr)
        myData.append("firma-sin", firmaSINStr)
        myData.append("firma-bos", firmaBase64OS)
        myData.append("firma-bsin", firmaBase64SIN)
        return axios.post(myCfg.url, myData)
    }

    doThePostTurismo(datos, firma, fileRecSueldo, fileDNI, fileDNI2) {
        var myData = new FormData();
        myData.append('mis_datos', JSON.stringify(datos));
       
        myData.append("firma", firma)
        myData.append("recibo_sueldo", fileRecSueldo)
        myData.append("dni", fileDNI)
        myData.append("dni-dorso", fileDNI2)
        return axios.post(myCfg.urlTurismo, myData)
    }

    getData(idSolicitud, nroTramite) {
        return axios.get(myCfg.urlBase+"/get_solicitud/"+idSolicitud+"/tramite/"+nroTramite)
    }

    getFirma(idSolicitud) {
        return axios.get(myCfg.urlBase+"/get_firma/"+idSolicitud)
    }

    validateDNI(dni) {
        return axios.get(myCfg.urlValidateDNI+dni)
    }
     
}

export default new ServiceBackend();